import DashboardService from '../services/dashboard.service';

const read = (query_string) => {
	return DashboardService.read(query_string).then(
		(response) => {
			return Promise.resolve(response.data);
		},
		(error) => {
			const message =
				(error.message && error.response.data && error.response.data.message) ||
				error.message ||
				error.toString();
			return Promise.reject(message);
		},
	);
};

const getUserLinks = (query_string) => {
	return DashboardService.getUserLinks(query_string).then(
		(response) => {
			return Promise.resolve(response.data);
		},
		(error) => {
			const message =
				(error.message && error.response.data && error.response.data.message) ||
				error.message ||
				error.toString();
			return Promise.reject(message);
		},
	);
};

export default { read, getUserLinks };
